import type { ComparisonRow, Verdict } from '../types/launch'

const verdicts = {
  screen_averages: { label: 'Screen averages', style: 'border-line bg-soft text-ink' },
  clear_difference: { label: 'Clear difference', style: 'border-notice-border bg-notice text-notice-ink' },
  possible_difference: { label: 'Possible difference', style: 'border-amber-200 bg-amber-50 text-amber-950' },
  within_normal_variation: { label: 'Within normal variation', style: 'border-line bg-soft text-ink' },
  not_enough_shots: { label: 'Not enough shots', style: 'border-line bg-paper text-muted' },
  not_measured: { label: 'Not recorded', style: 'border-line bg-paper text-muted' },
} satisfies Record<Verdict, { label: string; style: string }>

const missingLabels = {
  test: 'Not recorded in the test session',
  baseline: 'Not recorded in the baseline session',
  both: 'Not recorded in either session',
} satisfies Record<NonNullable<ComparisonRow['missing_in']>, string>

export default function VerdictBadge({ verdict, shotsNeeded, missingIn }: { verdict: Verdict; shotsNeeded: number; missingIn?: ComparisonRow['missing_in'] }) {
  const { label, style } = verdicts[verdict]
  let text = label
  if (verdict === 'not_enough_shots') text = `${label} — hit ${shotsNeeded} more`
  if (verdict === 'not_measured' && missingIn) text = missingLabels[missingIn]
  if (verdict === 'screen_averages' && missingIn) text = `${label} — ${missingLabels[missingIn].toLowerCase()}`
  return <span className={`inline-flex rounded-md border px-3 py-1.5 text-xs font-medium leading-5 ${style}`}>{text}</span>
}
